Vue.component('app-game-lobby', {
    mounted: function() {
        game.lobbyComponent = this;
    },
    data: function() {
        return {
            shouldShowModal: false,
            inviteLink: '',
            isScoreboard: false,
            timerMessage: '',
            playerCount: 0,
            currentPlayerData: {},
            data: {}
        };
    },
    methods: {
        showModal: function(val) {
            this.shouldShowModal = val;
        },
        updateData: function(data) {
            this.isScoreboard = data.menu === 'scoreboard';
            if (data.shareLinkToken && data.shareLinkToken.indexOf('undefined') === -1) {
                this.inviteLink = window.location.protocol + '//' + window.location.host + '?invite=' + data.shareLinkToken;
            } else {
                this.inviteLink = null;
            }
            this.data = data;
            this.playerCount = this.data.players.length;
            for (let i=0; i<this.data.teams.length; i++) {
                let team = this.data.teams[i];
                team.playerList = [];
                for (let j=0; j<this.data.players.length; j++) {
                    let player = this.data.players[j];
                    if (player.clientId === data.clientId) {
                        this.currentPlayerData = player;
                    }

                    if (player.team === team.id) {
                        if (player === this.currentPlayerData && this.currentPlayerData.isTeamLeader) {
                            team.isCurrentPlayerLeader = true;
                        }

                        team.playerList.push(player);
                        this.data.players.splice(j, 1);
                        j--;
                    }
                }
            }
        },
        updateRoundTimer: function(secondsTilStart) {
            if (secondsTilStart > 0) {
                this.timerMessage = 'Starting in ' + secondsTilStart + ' seconds';
            } else {
                this.timerMessage = 'Waiting for more players...';
            }
        },
        getTeamHex: function(teamId) {
            return game.getTeamHex(teamId);
        },
        ready: function() {
            game.mainSocket.emit('lobbyReady');
        },
        lockTeam: function(team) {
            game.mainSocket.emit('lobbyLockTeam');
            team.locked = !team.locked;
            this.$forceUpdate();
        },
        joinTeam: function(team) {
            game.mainSocket.emit('lobbyJoinTeam', team.id);
        },
        openPlayerMenu: function(player) {
            game.playerMenuComponent.openPlayerMenu(player, this.currentPlayerData);
        }
    },
    template: `
    <div class="game-modal" v-if="shouldShowModal">
        <div class="game-modal-content">
            <button v-if="isScoreboard" type="button" v-on:click="showModal(false)" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="row" v-if="!isScoreboard">
                <div class="app-card col" style="max-width:80%; margin:4px auto; min-height:130px;">
                    <button type="button" v-if="!currentPlayerData.ready" style="white-space:nowrap; float:right;" class="app-btn app-btn-primary app-btn-sm" v-on:click="ready()">
                        <i class="fa fa-check"></i> Ready
                    </button>
                    <h4>Lobby ({{playerCount}} Players)</h4>
                    <div v-for="(player, index) in data.players" style="font-size:16px; display:inline-block; margin:5px; width:auto;" class="app-card app-card-clickable app-card-sm" v-on:click="openPlayerMenu(player)">
                        <i class="fa fa-close" v-if="!player.ready" style="color:red;"></i>
                        <i class="fa fa-check" v-if="player.ready" style="color:green;"></i>
                        {{player.name}}
                    </div>
                </div>
            </div>

            <h4 v-if="!isScoreboard && data.state === 'lobby' && timerMessage">{{timerMessage}}</h4>
            <div v-if="data.privateGame">
                <br>
                <h4><i class="fa fa-lock"></i> Private Game</h4><small>Game is only able to be joined with the invite link below.<br>This game will not earn any XP.</small>       
            </div>
            <div v-if="data.gamemode === 'endless'">
                <br>
                <h4 style="color:#c9c90e;">
                    <i class="fa fa-exclamation"></i> Endless Mode <i class="fa fa-exclamation"></i>
                </h4>
                <small>
                    There is no way to win this gamemode, exist peacefully with others or battle for no reason. Help your team in whatever their goal is!<br>
                    Each player is limited to <b>5 following ants</b>, this gamemode is <b>not</b> for solo players, work with other players on your team! This gamemode will not earn any XP.<br>
                    Anthills and tunnels will decay and collapse without use, especially during rain. Teams are also able to respawn as a new queen again. <b>Queens cannot attack</b> in this mode.
                </small>       
            </div>
            <ul>
                <li v-for="(team, index) in data.teams" class="app-card lobby-card">    
                    <div style="display:inline-block; float:right;">
                        <div v-if="team.isCurrentPlayerLeader">
                            <button v-if="!team.locked && !team.dead" type="button" style="white-space:nowrap;" class="app-btn app-btn-secondary app-btn-sm" v-on:click="lockTeam(team)">
                                <i class="fa fa-lock"></i> Lock
                            </button>
                            <button v-if="team.locked && !team.dead" type="button" style="white-space:nowrap;" class="app-btn app-btn-secondary app-btn-sm" v-on:click="lockTeam(team)">
                                <i class="fa fa-unlock"></i> Unlock
                            </button>
                        </div>
                        <div v-if="!team.isCurrentPlayerLeader">
                            <button v-if="!team.locked && !team.dead && !isScoreboard && team.players < team.maxPlayers" type="button" style="white-space:nowrap;" class="app-btn app-btn-secondary app-btn-sm" v-on:click="joinTeam(team)">
                                Join
                            </button>
                            <span v-if="team.locked && !team.dead">
                                <i class="fa fa-lock"></i> Locked
                            </span>
                        </div>
                        <span v-if="team.dead">
                            <i class="fa fa-lock"></i> Dead
                        </span>
   
                    </div>
                    <h4 v-bind:style="{color:getTeamHex(team.id)}">{{team.name}} ({{team.players}}/{{team.maxPlayers}})</h4>
                    <div style="min-height:150px;">
                        <div v-for="(player, index) in team.playerList" class="app-card app-card-clickable app-card-sm" v-on:click="openPlayerMenu(player)">
                            <span v-if="!isScoreboard">
                                <i class="fa fa-close" v-if="!player.ready" style="color:red;"></i>
                                <i class="fa fa-check" v-if="player.ready" style="color:green;"></i>
                            </span>
                            {{player.name}} <i v-if="player.isTeamLeader" class="fa fa-star" style="color:yellow;"></i>
                        </div>
                    </div>
                    <span v-if="isScoreboard && team.score">
                        Score: {{team.score}}
                    </span>
                </li>
            </ul>
            <div style="max-width:400px; margin: 5px auto;" v-if="inviteLink">
                <h5>Invite Link</h5>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <button class="btn btn-outline-secondary" type="button" onclick="game.copyShareLink('scoreboard-menu-share-link');">Copy</button>
                    </div>
                    <input type="text" v-model="inviteLink" id="scoreboard-menu-share-link" class="form-control" placeholder="">
                </div>
            </div>
        </div>
    </div>
    `
})